<template>
  <div class="video-details">
    <view-header v-if="title" :header="title" />
    <div>
      <video-player v-if="videoSettings" :player-settings="videoSettings" />
    </div>
    <div class="chips-wrapper">
      <chip-label class="video-details__chip">Dodano dnia: {{ publishedAt }}</chip-label>
      <chip-label class="video-details__chip" v-if="settings.show_view_count">Wyświetleń: {{ viewed }} </chip-label>
    </div>
    <div class="video-details__desc" v-html="content"></div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapState } from 'vuex';
  import VideoPlayer from '../components/VideoPlayer';
  import ViewHeader from '../components/ViewHeader';
  import ChipLabel from '../components/ChipLabel';

  import { PortalService } from '../utils/portal-service';

  export default {
    name: 'Video',
    components: { ViewHeader, VideoPlayer, ChipLabel },
    metaInfo() {
      return {
        meta: [
          { title: `Portal | ${this.title}` },
          { description: `Portal | ${this.title}` },
        ],
      };
    },
    beforeRouteUpdate(to, from, next) {
      PortalService.getRecording(to.params.id)
        .then(res => {
          this.title = res.data.title;
          this.content = res.data.content;
          this.viewed = res.data.counter + 1;
          this.publishedAt = res.data.publishedAt;
          this.videoSettings = {
            srcUrl: res.data.videoUrl,
            srcDownloadUrl: res.data.videoDownloadUrl,
            subtitlesUrl: PortalService.getSubtitlesUrl(to.params.id),
          };
          if (!this.isVisited(this.$route.params.id)) {
            PortalService.updateVisitedCounter(this.$route.params.id, {
              count: this.count,
            });
          }
          next();
        })
        .catch(() => {
          next();
        });
    },
    data() {
      return {
        title: '',
        content: '',
        publishedAt: '',
        videoSettings: null,
        viewed: '',
      };
    },
    computed: {
      ...mapState('settings', ['settings']),
    },
    created() {
      PortalService.getRecording(this.$route.params.id)
        .then(async res => {
          document.title = `Portal | ${res.data.title}`;
          this.title = res.data.title;
          this.content = res.data.content;
          this.viewed = res.data.counter + 1;
          this.publishedAt = res.data.publishedAt;
          this.videoSettings = {
            srcUrl: await this.getVideoUrl(res.data.videoUrl, res.data.videoSmilUrl),
            srcDownloadUrl: res.data.videoDownloadUrl,
            subtitlesUrl: PortalService.getSubtitlesUrl(this.$route.params.id),
          };
        });
      if (!this.isVisited(this.$route.params.id)) {
        PortalService.updateVisitedCounter(this.$route.params.id, {
          count: this.count,
        });
      }
    },
    methods: {
      async getVideoUrl(mp4Url, smilUrl) {
        try {
          const response = await axios.head(smilUrl);
          return response.status === 200 ? smilUrl : mp4Url;
        } catch (error) {
          return mp4Url;
        }
      },
      isVisited(id) {
        let visited = JSON.parse(localStorage.getItem('video-recordings-visited'));
        visited = Array.isArray(visited) ? visited : [];

        if (visited.includes(id)) {
          return true;
        }

        visited.push(id);
        localStorage.setItem('video-recordings-visited', JSON.stringify(visited));

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .video-details {
    &__title {
      margin-bottom: 32px;
    }

    &__date {
      margin: 16px 0;
    }

    &__desc {
      margin-top: 32px;
    }
    &__chip {
      @at-root .high-contrast & {
        background-color: yellow;
        color: black;
      }
    }
  }
  .chips-wrapper {
    display: flex;
    justify-content: space-between;
  }
</style>
